import { GridColDef } from "@mui/x-data-grid-pro"
import { AccreditationRender } from "../../Datagrid/Renders/AccreditationRender"
import { AccreditationStateRender } from "../../Datagrid/Renders/AccreditationStateRender"
import { dateFormatter } from "../../FormatDate/FormatDate"

export default function getSubcontractColumns(hide?: string[]): GridColDef[] {

    const columns: GridColDef[] = [
        { field: "observations", headerName: "observações", width: 150, filterable: false },
        { field: "startDate", headerName: "data início", width: 140, valueGetter: dateFormatter, filterable: false, editable: false },
        { field: "endDate", headerName: "data fim", width: 140, valueGetter: dateFormatter, filterable: false, editable: false },
        { field: "concessionOrganizationAccreditation", headerName: "tipo acreditação", width: 190, renderCell: params => AccreditationRender(params), sortable: false, filterable: false },
        { field: "concessionOrganizationAccreditationState", headerName: "estado", width: 150, renderCell: AccreditationStateRender, filterable: false, sortable: false },

    ]

    if (!hide?.length) return columns
    return columns.filter(column => !hide.includes(column.field))
}
